<template>
  <div>
    <!-- edit shift modal -->
    <modal
      name="edit-shift-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-shift
        :selectedShift="selectedShift"
        :isSaveAndProceedButtonVisible="false"
        title="Uredi radno vrijeme"
        @saveAndCloseClicked="editShift"
      />
    </modal>

    <!-- add shift modal -->
    <modal
      name="add-shift-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-shift
        :selectedShift="selectedShift"
        :isSaveAndProceedButtonVisible="true"
        title="Dodaj radno vrijeme"
        @saveAndCloseClicked="addShift"
        @saveAndProceedClicked="addShiftAndContinue"
      />
    </modal>

    <!-- delete shift modal -->
    <modal
      name="delete-shift-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete radno vrijeme?"
        title="Obriši radno vrijeme"
        :selectedItem="selectedShift"
        @deleteButtonClicked="deleteShift"
      />
    </modal>

    <!-- Title -->
    <h1 class="title has-text-success">Radno vrijeme</h1>
    <h2 class="subtitle">Administracija radnog vremena u preduzeću</h2>

    <!-- Table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        searchFn: searchFunc,
        placeholder: 'Pretraži...',
      }"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'before'">
          <!-- edit icon -->
          <span class="icon has-text-info">
            <i
              class="fas fa-edit"
              v-show="props.row.isnew === false"
              @click="editRow(props.row)"
            >
              <font-awesome-icon icon="edit" />
            </i>
          </span>
          <!-- delete icon -->
          <span class="icon has-text-danger">
            <i
              class="fas fa-trash-alt"
              v-show="props.row.isnew === false"
              @click="deleteRow(props.row)"
            >
              <font-awesome-icon icon="trash-alt" />
            </i>
          </span>
          <!-- add new row button -->
          <button
            class="button is-info is-size-7"
            v-show="props.row.isnew === true"
            @click="addRow(props.row)"
          >
            Dodaj
          </button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import EditShift from "../parts/EditShift.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from "vue-good-table";
import { ShiftBack, ShiftFront } from "../../models/shift.js";

export default {
  components: {
    VueGoodTable,
    EditShift,
    DeleteItem,
  },
  name: "Shifts",
  data() {
    return {
      selectedShift: {},
      shifts: [],
      columns: [
        {
          label: "R.Br.",
          field: "shiftId",
          type: "number",
          sortable: false,
        },
        {
          label: "Ime",
          field: "name",
          sortable: false,
        },
        {
          label: "Opis",
          field: "description",
          sortable: false,
        },
        {
          label: "Fixed",
          field: "isStartTimeFixed",
          type: "boolean",
          sortable: false,
        },
        // {
        //   label: "Status",
        //   field: "status",
        //   type: "boolean",
        //   sortable: false,
        // },
        // {
        //   label: "Sektor",
        //   field: "department.name",
        //   sortable: false,
        // },
        // {
        //   label: "Grupa",
        //   field: "accessGroupId",
        //   sortable: false,
        // },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
      ],
      rows: [],
      errorMessage: "",
    };
  },
  mounted() {
    this.getShifts();
  },
  methods: {
    collectErrorMessage(error) {
      let msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return msg;
    },
    resetUi() {
      this.shifts = [];
      this.rows = [];
    },
    searchFunc(row, col, cellValue, searchTerm) {
      if (typeof cellValue === "string" || cellValue instanceof String) {
        return cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (cellValue == null) {
        return true;
      }
    },
    resetSelectedShift() {
      this.selectedShift = {};
    },
    getShifts() {
      UserService.getShifts().then(
        (response) => {
          // reset ui
          this.resetUi();

          // get new data
          // populate rows
          response.data.forEach((element) => {
            let shf = new ShiftFront(element);
            this.rows.push(shf);
          });
          // response.data.forEach((element) => {
          //   // populate shifts
          //   this.shifts.push({
          //     name: element.name,
          //     id: element.shiftId,
          //   });

          // });

          // add "add" row
          this.rows.push(
            new ShiftFront({
              isnew: true,
            })
          );
        },
        (error) => {
          this.collectErrorMessage(error);
        }
      );
    },
    editRow(shft) {
      this.selectedShift = new ShiftFront(shft);
      this.$modal.show("edit-shift-modal");
    },
    deleteRow(shft) {
      this.selectedShift = shft;
      this.$modal.show("delete-shift-modal");
    },
    addRow(shft) {
      this.selectedShift = shft;
      this.$modal.show("add-shift-modal");
    },
    editShift(shift) {
      let shiftToEdit = new ShiftBack(shift);

      UserService.putShift(shiftToEdit).then(
        () => {
          // reload ui
          this.resetUi();

          this.getShifts();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );

      this.$modal.hide("edit-shift-modal");
    },
    deleteShift() {
      let shiftToDelete = new ShiftBack(this.selectedShift);

      UserService.deleteShift(shiftToDelete).then(
        () => {
          // reload depts
          this.resetUi();

          this.getShifts();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
      this.$modal.hide("delete-shift-modal");
    },
    addShiftAndContinue(shift) {
      // create new employer
      let newShift = new ShiftBack(shift);

      // upload
      // call axios
      UserService.postShift(newShift).then(() => {
        // reset ui
        this.resetUi();

        this.getShifts();
      });
    },
    addShift(shift) {
      // create new employer
      let newShift = new ShiftBack(shift);

      // upload
      // call axios
      UserService.postShift(newShift).then(() => {
        // reset ui
        this.resetUi();

        this.getShifts();

        this.$modal.hide("add-shift-modal");
      });
    },
  },
};
</script>
